import React, { useEffect } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function TitleSync({ modulesToRender, flags }) {
  const location = useLocation()
  const { t } = useTranslation()

  useEffect(() => {
    const { pathname } = location
    let title = ''
    let founded = false;
    const staticTitles = [
      { path: '/', exact: true, title: t('Inicio') },
      { path: '/login', exact: true, title: t('Iniciar sesión') },
      { path: '/login_client', exact: true, title: t('Login Cliente') },
      { path: '/login_driver', exact: true, title: t('Login Operador') },
      { path: '/login_passenger', exact: true, title: t('Login Pasajero') },
      { path: '/login_supplier', exact: true, title: t('Login Proveedor') },
      { path: '/login_superadmin', exact: true, title: t('Login Super Admin') },

      { path: '/client/client_dashboard', title: t('Dashboard Cliente') },
      { path: '/client/passengers', exact: true, title: t('Pasajeros') },
      { path: '/client/passengers/:id', title: t('Detalle de Pasajero') },
      { path: '/client/passengers_report', title: t('Reporte de Pasajeros') },
      { path: '/client/groups_report', title: t('Reporte de Grupos') },
      { path: '/client/client_group_passengers', exact: true, title: t('Grupos de Pasajeros') },
      { path: '/client/client_group_passengers/:id', title: t('Grupo de Pasajeros') },
      { path: '/client/client_supervisor_passengers', exact: true, title: t('Supervisores de Pasajeros') },
      { path: '/client/client_supervisor_passengers/:id', title: t('Supervisor de Pasajeros') },
      { path: '/client/mobile_routes_report', title: t('Rutas Móviles') },
      { path: '/client/form_instance', title: t('Formularios') },
      { path: '/client/form_instance_report_detail', title: t('Detalle de Formulario') },
      { path: '/client/client_documents', title: t('Documentos') },
      { path: '/client/passenger_groups_report', title: t('Reporte de Grupos de Pasajeros') },
      { path: '/client/user', title: t('Usuarios del Cliente') },

      // Pasajero
      { path: '/passenger/passengers', title: t('Mi Perfil Pasajero') },
      { path: '/passenger/form_instance', title: t('Formularios Pasajero') },
      { path: '/passenger/form_instance_report_detail', title: t('Detalle Formulario Pasajero') },

      // Operador
      { path: '/driver/drivers', title: t('Operadores') },
      { path: '/driver/delivery_route_report', title: t('Reporte de Entregas') },
      { path: '/driver/client_visit', title: t('Visitas a Cliente') },
      { path: '/driver/driver_dashboard', title: t('Dashboard Operador') },
      { path: '/driver/driver_inspection_page', title: t('Inspección') },
      { path: '/driver/form_instances', title: t('Formularios Operador') },
      { path: '/driver/form_instances/:id', title: t('Formulario Operador') },
      { path: '/driver/create_form_instance', title: t('Crear Formulario Operador') },
      { path: '/driver/form_instance_report_detail', title: t('Detalle Formulario Operador') },

      // Proveedor
      { path: '/supplier/supplier_dashboard', title: t('Dashboard Proveedor') },
      { path: '/supplier/form_instance', title: t('Formularios Proveedor') },
      { path: '/supplier/form_instance_report_detail', title: t('Detalle Formulario Proveedor') },
      { path: '/supplier/supplier_documents', title: t('Documentos Proveedor') },

      // Super Admin / Asociados
      { path: '/sys_company_administrator', title: t('Consola Super Admin') },
      { path: '/modules_dashboard', title: t('Módulos') },
      { path: '/fuel_supply_template', exact: true, title: t('Plantillas de Carga de Combustible') },
      { path: '/fuel_supply_template/:id', title: t('Importar Plantilla') },
      { path: '/process_catalog', exact: true, title: t('Catálogo de Procesos') },
      { path: '/process_catalog/:id', title: t('Proceso') },
      { path: '/associates', exact: true, title: t('Asociados') },
      { path: '/associates/:id', title: t('Asociado') },
      { path: '/wizards_superAdmin', exact: true, title: t('Asistentes') },
      { path: '/wizards_superAdmin/:id', title: t('Asistente') },
      { path: '/procedures_superAdmin', exact: true, title: t('Procedimientos') },
      { path: '/procedures_superAdmin/:id', title: t('Procedimiento') },
      { path: '/impression_formats_superAdmin', exact: true, title: t('Formatos de Impresión') },
      { path: '/impression_formats_superAdmin/:id', title: t('Formato de Impresión') },
      { path: '/communications_superAdmin', exact: true, title: t('Comunicaciones') },
      { path: '/communications_superAdmin/:id', title: t('Comunicación') },
      { path: '/partner_billing', exact: true, title: t('Facturación de Socios') },
      { path: '/partner_billing/:id', exact: true, title: t('Facturación de Socio') },

      // Públicos
      { path: '/public_forms', exact: true, title: t('Formularios Públicos') },
      { path: '/public_forms/:id', title: t('Formulario Público') },

      // Configuración
      { path: '/settings/role', exact: true, title: t('Roles') },
      { path: '/settings/role/:id', title: t('Rol') },
      { path: '/temporary_exit_reasons', exact: true, title: t('Motivos de salida temporal') },
    ]

    // 2) Si hay módulos dinámicos con URL propia, usar su nombre
    if (flags.isAuthenticated && Array.isArray(modulesToRender)) {
      const modHit = modulesToRender.find(m =>
        matchPath(pathname, { path: `/${m.url}`, exact: false })
      )
      if (modHit?.name) { title = modHit.name; founded = true; }
    }

    const hit = staticTitles.find(cfg =>
      matchPath(pathname, { path: cfg.path, exact: cfg.exact ?? false })
    )
    if (hit?.title && !founded) title = hit.title
    // 3) Sufijo de marca
    document.title = `${title}`
  }, [location, modulesToRender, flags])

  return null
}
export default TitleSync;
